/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UseMemberDefaultProjectRolesQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID']['input'];
}>;


export type UseMemberDefaultProjectRolesQuery = { organisationMemberships: { __typename: 'OrganisationMembershipsConnection', edges: Array<{ __typename: 'OrganisationMembershipEdge', node: { __typename: 'User', id: string, defaultProjectRoles: Array<{ __typename: 'ProjectRole', id: string, internalName: string }> } }> } };


export const UseMemberDefaultProjectRolesDocument = gql`
    query UseMemberDefaultProjectRoles($memberId: ID!) {
  organisationMemberships(
    offset: 0
    limit: 1
    sorting: [{column: firstname, direction: asc}]
    filters: {ids: [$memberId]}
  ) {
    edges {
      node {
        id
        defaultProjectRoles {
          id
          internalName
        }
      }
    }
  }
}
    `;

/**
 * __useUseMemberDefaultProjectRolesQuery__
 *
 * To run a query within a React component, call `useUseMemberDefaultProjectRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseMemberDefaultProjectRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseMemberDefaultProjectRolesQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useUseMemberDefaultProjectRolesQuery(baseOptions: Apollo.QueryHookOptions<UseMemberDefaultProjectRolesQuery, UseMemberDefaultProjectRolesQueryVariables> & ({ variables: UseMemberDefaultProjectRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseMemberDefaultProjectRolesQuery, UseMemberDefaultProjectRolesQueryVariables>(UseMemberDefaultProjectRolesDocument, options);
      }
export function useUseMemberDefaultProjectRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseMemberDefaultProjectRolesQuery, UseMemberDefaultProjectRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseMemberDefaultProjectRolesQuery, UseMemberDefaultProjectRolesQueryVariables>(UseMemberDefaultProjectRolesDocument, options);
        }
export function useUseMemberDefaultProjectRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseMemberDefaultProjectRolesQuery, UseMemberDefaultProjectRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseMemberDefaultProjectRolesQuery, UseMemberDefaultProjectRolesQueryVariables>(UseMemberDefaultProjectRolesDocument, options);
        }
export type UseMemberDefaultProjectRolesQueryHookResult = ReturnType<typeof useUseMemberDefaultProjectRolesQuery>;
export type UseMemberDefaultProjectRolesLazyQueryHookResult = ReturnType<typeof useUseMemberDefaultProjectRolesLazyQuery>;
export type UseMemberDefaultProjectRolesSuspenseQueryHookResult = ReturnType<typeof useUseMemberDefaultProjectRolesSuspenseQuery>;
export type UseMemberDefaultProjectRolesQueryResult = Apollo.QueryResult<UseMemberDefaultProjectRolesQuery, UseMemberDefaultProjectRolesQueryVariables>;